import { render, staticRenderFns } from "./ICOverview.vue?vue&type=template&id=dedf20a8"
import script from "./ICOverview.vue?vue&type=script&lang=js"
export * from "./ICOverview.vue?vue&type=script&lang=js"
import style0 from "./ICOverview.vue?vue&type=style&index=0&id=dedf20a8&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports